import React from "react";
import LegalPage from "./LegalPage";

export default function AcceptableUse() {
  return (
    <LegalPage
      path="/acceptable-use"
      heading="Acceptable Use / Data Usage Policy"
      updated="September 2026"
      title="Acceptable Use Policy | Registry Feed"
      description="Rules for how Registry Feed subscribers may — and may not — use the MCA and GST company database."
    >
      <p>By subscribing to Registry Feed you agree to use the data responsibly and in compliance with applicable Indian laws. This Acceptable Use Policy sets the ground rules.</p>
      <h2>Permitted uses</h2>
      <ul>
        <li>B2B outreach to businesses relevant to your product or service.</li>
        <li>Internal research, market sizing and analysis.</li>
        <li>Enrichment of your CRM or lead-management system.</li>
        <li>Compliance, KYC, and due-diligence workflows.</li>
      </ul>
      <h2>Prohibited uses</h2>
      <ul>
        <li>Reselling, sublicensing, or publishing Registry Feed datasets, in whole or in part, in any form.</li>
        <li>Sending unsolicited bulk SMS, WhatsApp, calls or email in violation of TRAI regulations or applicable spam laws.</li>
        <li>Deceptive, fraudulent, or predatory outreach.</li>
        <li>Any use that violates Indian law, including the Information Technology Act, the Digital Personal Data Protection Act, and applicable telemarketing rules.</li>
        <li>Automated scraping or bulk-export beyond the reasonable download limits of the dashboard.</li>
        <li>Sharing your account credentials with unauthorised parties.</li>
      </ul>
      <h2>Enforcement</h2>
      <p>We may suspend or terminate any account that violates this policy, without refund and without prejudice to any other legal remedies. Serious violations may be reported to the appropriate authorities.</p>
      <h2>Reporting misuse</h2>
      <p>If you believe our data is being misused, please email us at sales@registryfeed.com so we can investigate.</p>
    </LegalPage>
  );
}
